import React, {useEffect, useState, useContext} from 'react';
import axios from 'axios';
import API_BASE_URL from '../../utils/apiBaseUrl';
import {Pagination } from 'react-bootstrap';
import { HourglassSplit } from 'react-bootstrap-icons';
import './CurrentWeek.css';
import { AccountContext } from './../../components/UserPool/Account';
import CurrentWeekNum from './../../utils/CurrentWeekNum';
import GetTargetDate from '../../utils/GetTargetDate';
import teamIcons from '../../utils/teamIcons';
import AlertModal from '../../components/AlertModal/AlertModal';

function CurrentWeek({year}) {
    const { getSession } = useContext(AccountContext);
    const [newSession, setNewSession] = useState(undefined);

    const [activePage, setActivePage] = useState(CurrentWeekNum(year));
    const [weekIsAvailable, setWeekIsAvailable] = useState(false);
    const [targetDate, setTargetDate] = useState(undefined);
    const [resultsArr, setResultsArr] = useState([[]]);
    const [allUserData, setAllUserData] = useState({});
    // Server truth for "is this week's Sunday-noon-CT deadline passed yet" --
    // fetched once per session (eligibility/currentWeek reflect the server's
    // *actual* current week regardless of which `week` param is passed) rather
    // than recomputed from the client's own hardcoded date tables, which have no
    // branch for 2026+ seasons.
    const [serverCurrentWeek, setServerCurrentWeek] = useState(null);
    const [serverEligibility, setServerEligibility] = useState(null);
    const [serverDeadlines, setServerDeadlines] = useState(null);

    const [selections, setSelections] = useState({
        'team': '',
        'users': [],
        'count': 0,
        'result': '',
    });
    // Live in-game scores, keyed by team name -- only fetched/polled while
    // looking at the actual current week (there's nothing "live" about a past
    // week). Not persisted anywhere server-side; each poll is a fresh ESPN
    // snapshot via /get-live-scores.
    const [liveScores, setLiveScores] = useState({});

    const monthNames = [
        'January', 'February', 'March', 'April', 'May', 'June',
        'July', 'August', 'September', 'October', 'November', 'December'
    ];

    const [showCurrWeekAlertModal, setShowCurrWeekAlertModal] = useState([false, '', ''])


    useEffect(() => {
        getSession(setNewSession)
          .then((session) => {
            console.log('Session Activated');
          })
          .catch((err) => {
            console.log('Session: ', err);
          });
        
      }, []);

    function sortPicks() {
        let teamToUser = {};
        let sortedUndecidedPicks = [];
        let sortedWinPicks = [];
        let sortedLossPicks = [];

        console.log('Sortin')
        console.log(allUserData)

        let currVal; let currTeam; let currUser;
        for(let i = 0; i < allUserData.length; i++) {
            currVal = allUserData[i];
            currTeam = Object.keys(Object.values(currVal)[0])[0];
            currUser = Object.keys(currVal)[0];

            // this is for adding a section for users who did not pick
            if(currTeam.includes('Team')) currTeam = 'N/A'

            if(teamToUser[currTeam]) teamToUser[currTeam].push(currUser)
            else teamToUser[currTeam] = [currUser]
        }


        let currLength;
        
        console.log(teamToUser)
        Object.keys(teamToUser).map((team, i) => {
            currLength = teamToUser[team].length;
            const result = resultsArr[activePage-1][team]
            let resultDesc;
            let isWin = false
            let isLoss = false
            let isUndecided = false
            let end = 0
            if(result === true){
                resultDesc = 'win'
                isWin = true
            } else if(result === false || team === 'N/A') {
                resultDesc = 'loss'
                isLoss = true
            } else {
                resultDesc = 'undecided'
                isUndecided = true
            }
 
            if(isWin) {
                end = sortedWinPicks.length
            } else if (isLoss) {
                end = sortedLossPicks.length
            } else {
                end = sortedUndecidedPicks.length
            }
            
            if(isWin && sortedWinPicks.length < 1) {
                sortedWinPicks = [[team, currLength,teamToUser[team], resultDesc]];
            } else if(isLoss && sortedLossPicks.length < 1) {
                sortedLossPicks = [[team, currLength,teamToUser[team], resultDesc]];
            } else if(isUndecided && sortedUndecidedPicks.length < 1) {
                sortedUndecidedPicks = [[team, currLength,teamToUser[team], resultDesc]];
            }

            for(let j = 1; j <= end; j++) {
                // console.log(isWin && sortedWinPicks.length && (currLength > sortedWinPicks[j-1][1] || sortedWinPicks[j-1][0] === 'N/A'))
                if (team === 'N/A') {
                    console.log("ISNA")
                    if(isWin) sortedWinPicks.push([team, currLength,teamToUser[team], resultDesc]);
                    else if(isLoss) sortedLossPicks.push([team, currLength,teamToUser[team], resultDesc]);
                    else sortedUndecidedPicks.push([team, currLength,teamToUser[team], resultDesc]);
                    break;
                }
                else if((isWin && sortedWinPicks.length && (currLength > sortedWinPicks[j-1][1] || sortedWinPicks[j-1][0] === 'N/A')) || (isLoss && sortedLossPicks.length && (currLength > sortedLossPicks[j-1][1] || sortedLossPicks[j-1][0] === 'N/A')) || (isUndecided && sortedUndecidedPicks.length && (currLength > sortedUndecidedPicks[j-1][1] || sortedUndecidedPicks[j-1][0] === 'N/A'))) {
                    console.log("INHERE")
                    if(isWin) sortedWinPicks.splice(j-1, 0, [team, currLength,teamToUser[team], resultDesc]);
                    else if(isLoss) sortedLossPicks.splice(j-1, 0, [team, currLength,teamToUser[team], resultDesc]);
                    else sortedUndecidedPicks.splice(j-1, 0, [team, currLength,teamToUser[team], resultDesc]);
                    break;
                } else if(j === end) {
                    console.log("ISJI")
                    if(isWin) sortedWinPicks.push([team, currLength,teamToUser[team], resultDesc]);
                    else if(isLoss) sortedLossPicks.push([team, currLength,teamToUser[team], resultDesc]);
                    else sortedUndecidedPicks.push([team, currLength,teamToUser[team], resultDesc]);
                }
            }

        });
        setSelections([...sortedUndecidedPicks, ...sortedWinPicks, ...sortedLossPicks]);
    }

    function getCurrentResults() {
        axios.get(`${API_BASE_URL}/admin-get-results`, {
            headers: {
                Authorization: newSession['idToken']['jwtToken'],
                'Content-Type': 'application/json'
            },
            params: {year}
        }).then((response) => {
            console.log(response['data']);
            setResultsArr(response['data']);
        }).catch((error) => {
            console.log(error); 
        })
    }

    function getMatchupsMeta(weekNum) {
        // Only used for its server-computed currentWeek/eligibility/deadlines --
        // authoritative for every year (matchups/deadlines/spreads are ignored
        // here), replacing the client's own hardcoded-date-table guesses which
        // have no branch for 2026+ seasons.
        axios.get(`${API_BASE_URL}/get-all-matchups`, {
            headers: {
                Authorization: newSession['idToken']['jwtToken'],
                'Content-Type': 'application/json'
            },
            params: {'username': matchupUsername(), year, 'week': weekNum}
        }).then((response) => {
            setServerCurrentWeek(response['data']['currentWeek']);
            setServerEligibility(response['data']['eligibility']);
            setServerDeadlines(response['data']['deadlines']);
        }).catch((error) => {
            console.log(error);
        });
    }

    function getLiveScores() {
        axios.get(`${API_BASE_URL}/get-live-scores`, {
            headers: {
                Authorization: newSession['idToken']['jwtToken'],
                'Content-Type': 'application/json'
            },
            params: {year}
        }).then((response) => {
            setLiveScores(response['data']['scores'] || {});
        }).catch((error) => {
            console.log(error);
        });
    }

    function matchupUsername() {
        const user = newSession['accessToken']['payload']['username']
        return user.includes('passwordless') ? user.split('-passwordless')[0] : user
    }

    // Is `weekNum`'s Sunday-noon-CT deadline in the past? Any week strictly
    // before the server's current week has necessarily already passed; the
    // current week itself uses the server's precomputed eligibility flag
    // directly; future weeks haven't happened yet.
    function isWeekPast(weekNum) {
        if (serverCurrentWeek == null) return null; // not loaded yet
        if (weekNum < serverCurrentWeek) return true;
        if (weekNum > serverCurrentWeek) return false;
        return serverEligibility === false;
    }

    function getAllPicks(weekNum) {
        if (isWeekPast(weekNum) !== true) {
            setShowCurrWeekAlertModal([true, 'Games will be available after 12pm CST kickoff.', 'We\'ve hit a snag'])
            return;
        }

        axios.get(`${API_BASE_URL}/all-users`, {
            headers: {
                Authorization: newSession['idToken']['jwtToken'],
                'Content-Type': 'application/json',
            },
            params: {'week_num': weekNum, year}
        }).then((response) => {
            console.log(response['data'])
            if('see_users' in response['data'] && !response['data']['see_users']) setWeekIsAvailable(false)
            else {
                console.log(response['data'])
                setAllUserData(response['data']);
            }
        }).catch((error) => {
            console.log(error); 
            setShowCurrWeekAlertModal([true, 'Unable to get picks for this week. Refresh the page and try again.', 'We\'ve hit a snag'])
        });
    } 
    
    useEffect(() => {
        if(newSession !== undefined) {
            getCurrentResults();
        }
    }, [allUserData])

    useEffect(() => {
        if(newSession !== undefined) {
            sortPicks();
        }
    }, [resultsArr])

    // Only the live/current week has anything worth polling for -- a past
    // week's games are long final, and a future week hasn't kicked off.
    useEffect(() => {
        if (newSession === undefined || serverCurrentWeek == null || activePage !== serverCurrentWeek) {
            return;
        }
        getLiveScores();
        const interval = setInterval(getLiveScores, 30000);
        return () => clearInterval(interval);
    }, [newSession, activePage, serverCurrentWeek])

    useEffect(() => {
        if (newSession !== undefined) {
            getMatchupsMeta(activePage);
        }
    }, [newSession, activePage]);

    // Once we learn the server's real current week, jump the initially-displayed
    // page to it if our synchronous CurrentWeekNum(year) placeholder guessed
    // wrong (only ever needed for 2026+ seasons) -- but only on first load, so
    // this doesn't fight the user's own pagination afterward.
    const hasAppliedInitialWeek = React.useRef(false);
    useEffect(() => {
        if (serverCurrentWeek != null && !hasAppliedInitialWeek.current) {
            hasAppliedInitialWeek.current = true;
            if (serverCurrentWeek !== activePage) {
                setActivePage(serverCurrentWeek);
            }
        }
    }, [serverCurrentWeek]);

    useEffect(() => {
        const past = isWeekPast(activePage);
        if (past === null) return; // server data not loaded yet, keep showing the spinner
        setWeekIsAvailable(past);

        // Exact deadline for this week, if we have real per-game deadlines from a
        // dynamically-synced schedule (2026+); otherwise fall back to the legacy
        // hardcoded date table for historical years' "come back at..." display.
        // For 2026+, GetTargetDate's fallback silently returns a *2025* date
        // (the season before this one) -- never call it for those years; leave
        // targetDate unset (its "come back once games kick off" text without a
        // specific date) rather than show a wrong one.
        const weekDeadlines = serverDeadlines && serverDeadlines[activePage-1];
        const isoDeadlines = weekDeadlines && weekDeadlines.filter((d) => typeof d === 'string' && d.includes('T'));
        if (isoDeadlines && isoDeadlines.length) {
            setTargetDate(new Date(Math.max(...isoDeadlines.map((d) => new Date(d).getTime()))));
        } else if (Number(year) < 2026) {
            setTargetDate(GetTargetDate(activePage, 'normal', year));
        } else {
            setTargetDate(undefined);
        }

        if (newSession !== undefined && past) {
            getAllPicks(activePage);
        }
    }, [newSession, activePage, serverCurrentWeek, serverEligibility, serverDeadlines]);

      // Total picks across every team this week, for the "% of pool" column --
      // picks made by others only become visible at all once the week is
      // revealed, so this is exactly the same reveal-gated data already shown,
      // just with a percentage alongside the raw count.
      // `selections` starts life as a plain object (see useState above) before
      // sortPicks() ever runs and replaces it with a real array -- guard with
      // Array.isArray rather than just truthiness, which a non-empty object
      // would still pass.
      const totalPicks = Array.isArray(selections) ? selections.reduce((sum, sel) => sum + (sel[1] || 0), 0) : 0;

      function formatLiveScore(team) {
          const live = liveScores[team];
          if (!live) return null;
          if (live.state === 'pre') return null;
          const scoreLine = `${live.score}-${live.opponentScore}`;
          if (live.state === 'post') return { text: `Final ${scoreLine}`, isLive: false };
          const clockLine = live.period ? `Q${live.period} ${live.clock || ''}`.trim() : (live.shortDetail || '');
          return { text: `${scoreLine} — ${clockLine}`, isLive: true };
      }

      let items = [];
      for(let i = 1; i < 19; ++i) {

        items.push(
            <Pagination.Item key={i} active={i === activePage} onClick={(event)=>{
                setActivePage(i);
            }}>
                {i}
            </Pagination.Item>
        );
    }

    if(!weekIsAvailable) {
        return (
            <>
                <div className='current-week-section'>
                    <div className='page-header'>
                        <h1 className='page-title'>Current Week</h1>
                        <p className='page-subtitle'>Who picked what, once picks are revealed</p>
                    </div>
                    <div className='spinner-section'>
                        <HourglassSplit className='come-back-later-icon' />
                        <p className='come-back-later-text'>
                           {
                              targetDate
                                ? 'Picks will be revealed at 12pm CST on ' + monthNames[targetDate.getMonth()] + ' ' + targetDate.getDate()
                                : 'Picks will be revealed at 12pm CST once this week\'s deadline passes'
                           }
                        </p>
                    </div>
                    <Pagination className='pagination-current-week'>{items}</Pagination>
                </div>

            </>
        )
    }


    return (
        <>
            <div className='current-week-section'>
                <div className='page-header'>
                    <h1 className='page-title'>Current Week</h1>
                    <p className='page-subtitle'>Who picked what, once picks are revealed</p>
                </div>
                <div className='current-week-list'>
                {
                    selections && selections.length
                        ? Object.keys(selections).map((val, i) => {
                            const isNoPick = selections[val][0] === 'N/A';
                            const resultClass = selections[val][3] === 'win' ? 'win' : (selections[val][3] === 'loss' ? 'loss' : '');
                            const pickCount = selections[val][1];
                            const pickPct = totalPicks ? Math.round((pickCount / totalPicks) * 100) : 0;
                            const users = selections[val][2] ? selections[val][2].join(', ') : '';
                            const NFLTeam = isNoPick ? null : teamIcons[selections[val][0]];
                            const live = isNoPick ? null : formatLiveScore(selections[val][0]);

                            return (
                                <div key={i} className={'current-week-row ' + resultClass}>
                                    <div className='current-week-row-top'>
                                        <div className='current-week-team'>
                                            {NFLTeam ? <NFLTeam/> : <span className='current-week-no-pick-icon'>&ndash;</span>}
                                            <span className='current-week-team-name'>{isNoPick ? 'No Pick' : selections[val][0]}</span>
                                        </div>
                                        {
                                            live &&
                                            <span className={'current-week-score' + (live.isLive ? ' in-progress' : '')}>{live.text}</span>
                                        }
                                    </div>
                                    <div className='current-week-pct-row'>
                                        <div className='current-week-pct-track'>
                                            <div className='current-week-pct-fill' style={{width: pickPct + '%'}} />
                                        </div>
                                        <span className='current-week-pct-label'>{pickCount} &middot; {pickPct}%</span>
                                    </div>
                                    {
                                        users &&
                                        <div className='current-week-users'>{users}</div>
                                    }
                                </div>
                            )
                        })
                        : <p className='current-week-empty'>No picks to show for this week.</p>
                }
                </div>
            </div>
            <Pagination className='pagination-current-week'>{items}</Pagination>
            <AlertModal
                    show={showCurrWeekAlertModal[0]}
                    onHide={()=>{setShowCurrWeekAlertModal([false, '', ''])}}
                    modalTitle={showCurrWeekAlertModal[2]}
                    modalBody={showCurrWeekAlertModal[1]}
            />   
        </>
    )
}

export default CurrentWeek;